import { useEffect, useState } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { dealerSchema } from "../schema";

export const useDealer = (dealerId) => {
  const [dealer, setDealer] = useState();
  const [value, loading, error] = useDocument(doc(db, "dealers", dealerId), {
    snapshotListenOptions: { includeMetadataChanges: true },
  });
  useEffect(() => {
    if (value) {
      setDealer(mapDealer(value));
    }
  }, [value]);

  return { dealer, loading, error };
};

const mapDealer = (snapshot) => {
  const data = snapshot.data();
  return dealerSchema.cast({
    id: snapshot.id,
    ...data,
  });
};
